<template>
  <div class="NewsDetail">
    <section-header heading="2" ja="BTSキャラクター「TinyTAN」期間限定イベント開催！"/>
    <div>
      <div class="text-area">
        22.05.27
        <br><br>
        BTSキャラクター「TinyTAN」期間限定イベント開催！
        <br>
        TinyTANキャラクターがスタンプ、フレーム、シールになって登場！
        <br><br>
        <img
          src="@/assets/Png/News/TinyTAN/image_news_Tiny_Tan_collabo.png"
          style="max-width: 100%;">
        <br><br>
        ■実施期間
        <br><br>
        2022年6月1日（水）～ 2022年7月4日（月）
        <br><br>
        ■対象機種
        <br><br>
        <center>『meityromantic（メイロマ）』</center>
        <br><br>
        <img
          src="@/assets/Png/News/TinyTAN/image_news_meityromantic.jpg"
          style="max-width: 100%;">
        <br><br>
        <center>遊べるお店は<a href="https://o.puri.jp/appfw/locationMeiroma/">こちら</a></center>
        <br><br>
        ■内容
        <br><br>
        スタンプ…全24種、フレーム…全5種、シールデザイン…全1種
        <br><br>
        ◆「TinyTAN」限定スタンプ（一部）
        <br><br>
        <img
          src="@/assets/Png/News/TinyTAN/image_news_Tiny_Tan_collabo03.png"
          style="max-width: 100%;">
        <br><br><br>
        ◆シールイメージ
        <br><br>
        <center>
          <img
            src="@/assets/Png/News/TinyTAN/image_news_Tiny_Tan_collabo02.jpg"
            style="max-width: 50%;">
        </center>
        <br><br>
        ◆らくがき画面
        <br><br>
        <img
          src="@/assets/Png/News/TinyTAN/image_news_Tiny_Tan_collabo01.png"
          style="max-width: 100%;">
        <br><br>
        <center>遊べるお店は<a href="https://o.puri.jp/appfw/locationMeiroma/">こちら</a></center>
        <br><br>
        ■TinyTANとは
        <br><br>
        BTSメンバー7人が、かわいいTinyTANキャラクターとして誕生しました！<br>
        MAGIC DOORを通じて現実世界を行き来するTinyTAN。<br>
        ある日突然魔法のように現れ、皆さまを癒す秘密の友だちになってくれるでしょう。<br><br>
        セガ公式SNSでもコラボ情報を発信中！<br><br>
        <div class="snsWrapper --snsIcons">
          <a class="snsIcon" href="https://www.instagram.com/sega_purikura/">
            <img src="https://d4.puri.jp/dev/banner/news/Linkicon_01_IG.jpg">
          </a>
          <a class="snsIcon --x" href="https://twitter.com/SEGA_purikura/">
            <img src="@/assets/Png/SNS/Twitter_Social_Icon_Rounded_Square_Color.png">
          </a>
        </div>
        <div class="centerBlock">
          <a href="https://www.instagram.com/sega_purikura/">Instagram</a><a href="https://twitter.com/SEGA_purikura/">X(旧Twitter)</a>
        </div>
      </div>
    </div>
    <sub-btn @click="onNewsList()">みんなへのお知らせ一覧に戻る</sub-btn>
    <sub-btn @click="onHome()">ホームに戻る</sub-btn>
  </div>
</template>

<script>
import Protobuf from '../mixins/protobuf'
import SectionHeader from "../components/SectionHeader";
import SubBtn from '../components/SubBtn.vue'

export default {
  name: "NewsDetail",
  components: {SectionHeader, SubBtn},
  mixins: [Protobuf],
  data() {
    return {
      title: "",
      img: "",
      description: "",
    }
  },
  methods: {
    onNewsList() {
      this.$router.push('/newsList')
    },
    onHome() {
      this.$router.push('/')
    },
  }
}
</script>

<style lang="scss" scoped>
.NewsDetail {
  .text-area {
    margin: 30px 30px 0;
    font-size: 12px;
    color: #373737;
    img {
      max-width: 100%;
    }
    .edge {
      box-shadow: 0 0 5px rgba(0,0,0,0.12);
    }
    p {
      margin-top: 1em;
    }

    .snsIcon {
      display: inline-block;
      height: 67px;
      img {
        height: 67px;
      }
    }
    .--x {
      height: 49px;
      img {
        width: 49px;
        height: 100%;
      }
    }

    .snsWrapper {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      &>a:nth-of-type(1){
        margin-right: 20px;
      }
      &>a:nth-of-type(2){
        margin-right: 30px;
      }
    }
    .centerBlock {
      display: flex;
      justify-content: center;
      & > img:last-of-type,
      & > a:last-of-type { margin-left: 20px; }
    }
  }
}
</style>
